import Profile from "@/views/Profile/Profile"

const profileRoutes = [
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: { authorize: [] },
    },
]

export default profileRoutes;
